/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Card, CardContent } from '../../../Shared/Card'
import { useQuery } from '@tanstack/react-query'
import { getPosDevices } from '../../../../../services/PointOfSale/PointOfSale.service'
import { TIME } from '../../../../../services/date.service'
import useUser from '../../../../Shared/UserProvider/useUser'
import { useTranslation } from 'react-i18next'
import { LoadingPlaceholderCardContent } from '../../../Shared/LoadingPlaceholderCardContent'
import { Icon, IconGroup } from 'semantic-ui-react'

const DevicesCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['devices', user.provider.object.id],
        queryFn: () => getPosDevices(user.provider.object.id),
        staleTime: TIME.HOUR_IN_MS * 4,
    })

    return (
      <Card
        css={css`
            .card-content {
                width: 283px;
                height: 80px;
            }
        `}
      >
          <CardContent
            className="card-content"
            css={css`
                display: flex;
                column-gap: 1rem;
                justify-content: center;
                align-items: center;
                padding: ${isLoading ? '0' : '1rem'};
            `}
          >
              {isLoading ? (
                <LoadingPlaceholderCardContent/>
              ) : (
                <>
                <IconGroup size="big">
                    <Icon color="grey" name="tablet alternate"/>
                    <Icon
                      corner
                      name={data.devicesCount === 0 ? 'ban' : 'checkmark'}
                      color={data.devicesCount === 0 ? 'grey' : 'green'}
                    />
                </IconGroup>
                <p
                  css={css`
                      font-weight: bold;
                  `}
                >
                    {data.devicesCount > 0 ?
                      t('device.count_device_connected', {count: data.devicesCount}) :
                      t('device.no_device_connected')
                    }
                </p>
                </>
                )}
            </CardContent>
        </Card>
    )
}

export {DevicesCard}
